import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useAuth } from "../../authentication";
import { Image } from 'antd';
import * as globalFunction from 'util/GlobalFunction';
import { config } from "util/config";

import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { authUser } = useAuth();
  const { width, themeType } = useSelector(({ settings }) => settings);
  const [imgSrc, setImgSrc] = useState('/assets/images/company-logo/' + authUser.CompanyId + '.png?t=' + globalFunction.formatDateToVersion());
  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }

  return (
    <div className="gx-layout-sider-header">
      <Link to="/dashboard" className="gx-site-logo">
        {navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE ?
          <img alt="lo" src={("/assets/images/w-logo.png")} /> :
          themeType === THEME_TYPE_LITE ?
            <img alt="logo" src={("/assets/images/logo-white.png")} /> :
            <img alt="logo"
              className="sidebar-Logo"
              src={imgSrc}
              onError={() => setImgSrc('/assets/images/company-logo/1.png?t=' + globalFunction.formatDateToVersion())}
            />}
      </Link>
      {(navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) ? <div className="gx-linebar">
        <i
          className={`gx-icon-btn icon icon-${!sidebarCollapsed ? 'menu-unfold' : 'menu-fold'} ${themeType !== THEME_TYPE_LITE ? 'gx-text-white' : ''}`}
          onClick={() => {
            setSidebarCollapsed(!sidebarCollapsed)
          }}
        />
      </div> : null}
    </div>
  );
};

export default SidebarLogo;
